import { createStore } from 'vuex'
import type { RootState } from '@/types/store'

import Api from './modules/api'
import App from './modules/app'
import Appointment from './modules/appointment'
import Business from './modules/business'
import CashRegister from './modules/cash-register'
import Identity from './modules/identity'
import RoutingConfig from './modules/routing-config'
import Subscription from './modules/subscription'

import AttachableIndex from './modules/ui/attachable-index'
import Overlay from './modules/ui/overlay'
import LoadingScreen from './modules/ui/loading-screen'

const debug = process.env.NODE_ENV !== 'production'

export const store = createStore<RootState>({
  strict: debug,
  modules: {
    app: App,
    appointment: Appointment,
    api: Api,
    business: Business,
    cashRegister: CashRegister,
    identity: Identity,
    routingConfig: RoutingConfig,
    attachableIndex: AttachableIndex,
    overlay: Overlay,
    loadingScreen: LoadingScreen,
    subscription: Subscription,
  },
})
